module.exports = __webpack_public_path__ + "media/images/common/side_bg_top-b89cb0f90049a4d566518b0fc23c8f54.gif";